import {
	createContext,
	type Dispatch,
	type FC,
	type ReactNode,
	type SetStateAction,
	useContext,
	useState,
} from "react";
import type { TabIds } from "./broadcast-portal.types";

type BroadcastPortalContextValue = {
	activeTeam: TabIds;
	setActiveTeam: Dispatch<SetStateAction<TabIds>>;
};

const BroadcastPortalContext = createContext<
	BroadcastPortalContextValue | undefined
>(undefined);

export const useBroadcastPortalContext = () => {
	const broadcastPortalContext = useContext(BroadcastPortalContext);
	if (broadcastPortalContext === undefined) {
		throw new Error(
			"useBroadcastPortalContext must be inside a BroadcastPortalProvider",
		);
	}
	return broadcastPortalContext;
};

// For components (e.g. FormationsModule) shared between the broadcaster
// portal and the viewer journey — the viewer never has a
// BroadcastPortalProvider, so this returns undefined there instead of
// throwing, letting the caller fall back to its own local state.
export const useOptionalBroadcastPortalContext = () =>
	useContext(BroadcastPortalContext);

export const BroadcastPortalProvider: FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [activeTeam, setActiveTeam] = useState<TabIds>("homeTeam");

	return (
		<BroadcastPortalContext.Provider value={{ activeTeam, setActiveTeam }}>
			{children}
		</BroadcastPortalContext.Provider>
	);
};
